import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-197228ef"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "show-box" }


import {PasswordFieldType} from '@/components/business/crud/interface/FieldType';
import {WidgetInfo} from "@/components/business/crud/widgets/WidgetContainer";


export default /*#__PURE__*/_defineComponent({
  __name: 'PasswordTable',
  props: {
    propName: {},
    widget: {},
    info: {},
    data: {}
  },
  setup(__props: any) {

const props = __props;


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.data[_ctx.propName + 'Set'] ? '已设置' : '未设置'), 1))
}
}

})